import React, { useEffect } from "react";
import { Header } from "../components/Common/Header";
import { InfoCard } from "../components/Information/InfoCard";
import { Parallex } from "../components/Common/Parallax";
import { ReactComponent as Mission } from "../assets/icons/mission.svg";
import { ReactComponent as Vision } from "../assets/icons/vision.svg";
import { ReactComponent as Goal } from "../assets/icons/goal.svg";

import BgImage from "../assets/images/Headers/AboutUs.jpg";
import Book from "../assets/images/book-in-hands.webp";
import Puzzle from "../assets/images/team-solving-a-puzzle.webp";
import WhyChoose from "../assets/images/AboutUs/Picsolus.jpg";

export const AboutUs = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
      <Header
        image={BgImage}
        title="About CTB"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "50px",
          gap: "30px",
          flexWrap: "wrap",
        }}
        data-aos="fade"
      >
        <InfoCard
          subtitle="Our"
          title="Mission"
          caption="To offer coaching and mentorship that inspires self-discovery, builds confidence, and provides tools for personal and professional success."
          type={1}
        >
          <Mission width="30" height="30" />
        </InfoCard>
        <InfoCard
          subtitle="Our"
          title="Vision"
          caption="To empower individuals to overcome challenges, unlock their potential, and thrive with purpose and fulfillment."
          type={1}
        >
          <Vision width="30" height="30" />
        </InfoCard>
        <InfoCard
          subtitle="Our"
          title="Goal"
          caption="To empower individuals to unlock their full potential, achieve personal growth, and foster a meaningful, fulfilling life journey."
          type={1}
        >
          <Goal width="30" height="30" />
        </InfoCard>
      </div>

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{ fontSize: "16px", textAlign: "left" }}
              data-aos="fade"
            >
              About Us
            </p>
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2", // Adjust line-height for readability
              }}
              data-aos="fade"
            >
              Welcome to Come To Be Coaching
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6", // Add spacing between lines for readability
              }}
              data-aos="fade"
            >
              At ComeToBe Coaching, we're dedicated to helping you unlock your
              true potential and achieve the goals that matter most to you. As a
              certified life coach, I offer tailored, one-on-one coaching
              sessions designed to guide you through life’s challenges, helping
              you grow and thrive. Whether you're seeking personal development,
              career growth, or improved well-being, we’ll work together to
              create a roadmap to success and build a life you truly love.
            </p>
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4 / 3",
            }}
            data-aos="fade"
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={Book}
              alt={"book opened in two hands"}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap-reverse", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4 / 3",
            }}
            data-aos="fade"
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={Puzzle}
              alt="Team solving a puzzle"
            />
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2", // Adjust line-height for readability
              }}
              data-aos="fade"
            >
              Our Story
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6", // Add spacing between lines for readability
              }}
              data-aos="fade"
            >
              CTB was born out of a passion for helping individuals and
              organisations thrive. Founded in 2016 by Mr. Sunil Verma, MCC. with
              a background in learning and development , we recognised the
              transformative power of coaching and its potential to unlock
              exceptional results. Over the years, we've grown into a leading
              provider of coaching and facilitation services across South Asia,
              with a team of experienced coaches dedicated to your success.
            </p>
          </div>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2", // Adjust line-height for readability
              }}
              data-aos="fade"
            >
              Why Choose CTB?
            </p>
            {[
              {
                title: "ICF-Accredited Coaches:",
                description:
                  "Our coaches are credentialed by the International Coaching Federation (ICF), the gold standard in the coaching industry, ensuring you receive the highest quality coaching available.",
              },
              {
                title: "Data-Driven Results:",
                description:
                  "We are committed to providing measurable outcomes. Our coaching programs are grounded in evidence-based practices and designed to achieve your specific goals.",
              },
              {
                title: "Bespoke Solutions:",
                description:
                  "We take a personalized approach, tailoring our coaching programs to your unique needs and objectives.",
              },
              {
                title: "Experienced Team:",
                description:
                  "Our team consists of highly experienced coaches with diverse backgrounds and a passion for helping you succeed.",
              },
            ].map((section, index) => (
              <div key={index} style={{ marginBottom: "20px" }}>
                <p
                  style={{
                    fontSize: "16px",
                    textAlign: "left",
                    lineHeight: "1.6",
                    fontWeight: "bold",
                  }}
                  data-aos="fade"
                >
                  {section.title}
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    textAlign: "left",
                    lineHeight: "1.6",
                  }}
                  data-aos="fade"
                >
                  {section.description}
                </p>
              </div>
            ))}
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4/3",
            }}
            data-aos="fade"
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={WhyChoose}
              alt={WhyChoose}
            />
          </div>
        </div>
      </div>

      <Parallex
        image={BgImage}
        title="Our progress never Ends"
        top_subtitle="Our Achievements"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "50px",
            justifyContent: "center",
            marginBottom: "30px"
          }}
          data-aos="fade"
        >
          <div>
            <p
              style={{
                fontSize: "40px",
                lineHeight: "1.6",
                fontWeight: "bold",
              }}
            >
              10+
            </p>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
              }}
            >
             Services/Courses
            </p>
          </div>
          <div>
            <p
              style={{
                fontSize: "40px",
                lineHeight: "1.6",
                fontWeight: "bold",
              }}
            >
              20+
            </p>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
              }}
            >
              MNCs 
            </p>
          </div>
          <div>
            <p
              style={{
                fontSize: "40px",
                lineHeight: "1.6",
                fontWeight: "bold",
              }}
            >
              400+
            </p>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
              }}
            >
              Certified students
            </p>
          </div>
        </div>
      </Parallex>
    </>
  );
};